class ContextMenuOption {
  constructor(
    public action: string,
    public label: string,
    public props?: Array<any>
  ) {}
}

export default ContextMenuOption;
